/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-19 16:55:20
 * @LastEditors: 肖玲
 * @Description:
 * 档案关系维护
 */

const fileRelationshipRouter = [
  // 九新 -- 代理关系 6代理关系 9服务商关系
  {
    path: '/masterDataSystem/agent-relation/:meta_type',
    name: 'behaviorManageAgentRelation',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemImportAgent" */
        // '@/views/behaviorManage/jiuxin/AgentRelation.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      6: {
        title: '代理关系',
      },
      9: {
        title: '服务商关系',
      },
    },
  },

  // 九新 代理关系 -- 代理关系详情
  {
    path: '/masterDataSystem/agent-relation-details/:id/:approval_status/:agency_relation_id/:meta_type',
    name: 'behaviorManageAgentRelationDetails',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemImportAgent" */
        // '@/views/behaviorManage/jiuxin/AgentRelationDetails.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/Details.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      6: {
        title: '代理关系详情',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      9: {
        title: '服务商关系详情',
        breadcrumb: [
          {
            title: '服务商关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
    },
  },

  // 代理关系  删除记录
  {
    path: '/masterDataSystem/delete-record/:meta_type',
    name: 'masterDataSystemDeleteRecord',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemDeleteRecord" */
        // '@/views/behaviorManage/jiuxin/DeleteRecord.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/del-record/Page.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      6: {
        title: '删除记录',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      9: {
        title: '删除记录',
        breadcrumb: [
          {
            title: '服务商关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
    },
  },

  // 代理关系  删除记录 导出
  {
    path: '/masterDataSystem/delete-record-export/:meta_type',
    name: 'masterDataSystemDeleteRecordExport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemDeleteRecordExport" */
        // '@/views/behaviorManage/jiuxin/DeleteRecordExport.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/del-record/Export.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      6: {
        title: '导出代理关系',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
          {
            title: '删除记录',
            name: 'masterDataSystemDeleteRecord',
          },
        ],
      },
      9: {
        title: '导出服务商关系',
        breadcrumb: [
          {
            title: '服务商关系',
            name: 'behaviorManageAgentRelation',
          },
          {
            title: '删除记录',
            name: 'masterDataSystemDeleteRecord',
          },
        ],
      },
    },
  },

  // 代理关系  更新代理关系
  {
    path: '/masterDataSystem/update-agent/:meta_type',
    name: 'masterDataSystemUpdateAgent',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemUpdateAgent" */
        // '@/views/behaviorManage/jiuxin/UpdateAgent.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/Update.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      6: {
        title: '更新代理关系',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      9: {
        title: '更新服务商关系',
        breadcrumb: [
          {
            title: '服务商关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
    },
  },

  // 九新 代理关系 -- 导入操作 新增进药品规 导入终止时间 删除代理关系
  {
    path: '/masterDataSystem/agent-import/:meta_type/:cls',
    name: 'behaviorManageAgentImport',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManage5" */
        // '@/views/behaviorManage/jiuxin/AgentImport.vue'
        '@/views/master-data/file-operation-manage/file-relationship/agent-relation/Import.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      isMoreMeta: true,
      1: {
        title: '导入完整关系',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      2: {
        title: '新增进药品规',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      3: {
        title: '导入终止时间',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      4: {
        title: '删除',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
      5: {
        title: '导出',
        breadcrumb: [
          {
            title: '代理关系',
            name: 'behaviorManageAgentRelation',
          },
        ],
      },
    },
  },

  // 九新 代理关系 -- 批量审批
  {
    path: '/masterDataSystem/agent-batch-approval-import',
    name: 'behaviorManageAgentBatchApprovalImport',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageAgentBatchApprovalImport" */
        '@/views/behaviorManage/jiuxin/BatchApprovalImport'
        // '@/views/master-data/file-operation-manage/file-relationship/agent-relation/Approval.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      title: '批量审批',
      breadcrumb: [
        {
          title: '代理关系',
          name: 'behaviorManageAgentRelation',
        },
      ],
    },
  },

  // 商业子公司
  {
    path: '/masterDataSystem/subsidiary',
    name: 'masterDataSystemSubsidiary',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemSubsidiary" */
        '@/views/masterDataSystem/subsidiary/List'
        // '@/views/master-data/file-operation-manage/file-relationship/subsidiary/Page.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      title: '商业子公司',
    },
  },

  // 批量导入子公司
  {
    path: '/masterDataSystem/subsidiary/import',
    name: 'masterDataSystemImport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemSubsidiary" */
        // '@/views/masterDataSystem/subsidiary/ImportSon'
        '@/views/master-data/file-operation-manage/file-relationship/subsidiary/Import.vue'
      ),
    meta: {
      SecondaryMenu: '档案关系维护', //二级菜单
      title: '批量导入子公司',
      breadcrumb: [
        {
          title: '商业子公司',
          name: 'masterDataSystemSubsidiary',
        },
      ],
    },
  },
]

export default fileRelationshipRouter
